/* eslint-disable react/prop-types, react/no-danger */
import React from 'react';

const FRAME_STYLE = {
  border: 0,
  height: '65vh',
  width: '100%',
};

const normalizeHtml = (html) =>
  String(html || '').replace(
    /(on[a-z]+)="([a-z_$][a-z0-9_$]*[(])"([^"]*)"([^"]*)"/gi,
    (match, eventName, handlerStart, argument, handlerEnd) =>
      [eventName, '="', handlerStart, "'", argument, "'", handlerEnd, '"'].join(
        '',
      ),
  );

function FareRulesContent({ html, className, style }) {
  if (!/<script|(?:^|[ <])on[a-z]+[ ]*=/i.test(html)) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        className={className}
        style={style}
      />
    );
  }

  return (
    <iframe
      title="Fare rules content"
      srcDoc={normalizeHtml(html)}
      sandbox="allow-scripts"
      className={className}
      style={FRAME_STYLE}
    />
  );
}

export default FareRulesContent;
